const AUTH_TYPE_STORAGE_KEY = 'auth_type';

/**
 * Paths that must never be preserved as a `redirectPath`. The param is only
 * ever replayed once the user has signed back in, so `/logout` would sign them
 * straight back out, and `/` is already where MSAL lands them after login.
 */
const NON_REDIRECTABLE_PATHS = ['/', '/logout'];

/**
 * True when a path is worth preserving as a `redirectPath` for after login.
 * @param pathname - Location pathname, without the query string
 */
export const isRedirectablePath = (pathname: string): boolean =>
  !NON_REDIRECTABLE_PATHS.includes(pathname);

export const authStorage = {
  auth_type: {
    getAuthType(): string | null {
      try {
        return localStorage.getItem(AUTH_TYPE_STORAGE_KEY);
      } catch (error) {
        console.error('Failed to get auth type from localStorage:', error);
        return null;
      }
    },

    setAuthType(authType: string): void {
      try {
        localStorage.setItem(AUTH_TYPE_STORAGE_KEY, authType);
      } catch (error) {
        console.error('Failed to set auth type in localStorage:', error);
      }
    },

    clearAuthType(): void {
      try {
        localStorage.removeItem(AUTH_TYPE_STORAGE_KEY);
      } catch (error) {
        console.error('Failed to clear auth type from localStorage:', error);
      }
    },
  },
};
